/**
 * Types for authored YAML fields (field-yaml-format.md).
 * Pure domain types — no I/O, no adapters.
 */

import type { Cell, FieldId, BuildingType, GemType } from "./types.js";

export type CellRole =
  | "blockedA"
  | "blockedB"
  | "buildable"
  | "path"
  | "entry"
  | "exit"
  | "prebuiltChapel"
  | "prebuiltWall"
  | "prebuiltTrap"
  | "prebuiltAmp"
  | "prebuiltShrine";

export interface FieldGrid {
  rows: number;
  cols: number;
  /** row-major; length = rows*cols */
  cells: CellRole[];
}

export interface AuthoredField {
  id: FieldId;
  wavesNum: number;
  monsterBaseHp: number;
  armorGrowthRate: number;
  firstWaveDelayMs: number;
  interWaveDelayMs: number;
  initialMana?: number;
  monstersPerWave?: number;
  spawnIntervalMs?: number;
  grid: FieldGrid;
  /** Entry cells where monsters spawn (role = "entry" / "<"). Row-major order. */
  entryCells: Cell[];
  /** Single exit cell (role = "exit" / ">"). */
  exitCell: Cell;
  /** All walkable cells: path + entry + exit. */
  walkableCells: Cell[];
  /** All impassable non-buildable cells: blockedA + blockedB. */
  blockedCells: Cell[];
  /** Pre-placed buildings at game start. */
  prebuiltBuildings: Array<{ cell: Cell; type: BuildingType }>;
  /** Whitelist of gem types the player may create. Undefined = all types allowed. */
  allowedGemTypes?: GemType[];
}

export const GLYPH_TO_ROLE: Record<string, CellRole> = {
  "#": "blockedA",
  "~": "blockedB",
  ".": "buildable",
  p: "path",
  "<": "entry",
  ">": "exit",
  C: "prebuiltChapel",
  W: "prebuiltWall",
  T: "prebuiltTrap",
  A: "prebuiltAmp",
  S: "prebuiltShrine",
};
